const theme = {
  colors: {
    background: {
      orange: '#F77403',
      white: '#FAFAFA',
      gray: '#F2F2F2',
    },

    orange: {
      dark: '#4D290A',
      pressing: '#D9731C',
      primary: '#F58220',
      light: '#F5C093',
    },

    blue: {
      pressing: '#004D8C',
      primary: '#005FAE',
      medium: '#3477AE',
      light: '#0C9AD7',
    },

    yellow: {
      pressing: '#D99837',
      primary: '#FBB040',
      light: '#FDD69B',
      text: '#EDB903',
    },

    green: {
      primary: '#2EB033',
      light: '#D1E9D9',
    },

    gray: {
      100: '#FAFAFA',
      200: '#F2F2F2',
      300: '#E5E4E5',
      400: '#CCCBCC',
      500: '#807E80',
      600: '#4D4C4D',
      700: '#424242',
      900: '#1A191A',
      table: '#F9F9F9',
      debtsTable: '#EDEDED',
    },

    red: {
      primary: '#CA1818',
      light: '#FF9B88',
    },

    white: '#fff',

    attention: '#CA1818',
    succesful: '#2EB033',

    byUf: {
      AC: '#F77403',
      AL: '#F5C093',
      AP: '#F58220',
      AM: '#732C2C',
      BA: '#FBB040',
      CE: '#2EB033',
      DF: '#CA1818',
      ES: '#FFA800',
      GO: '#FFDB58',
      MA: '#FF8C00',
      MT: '#0071BC',
      MS: '#FFD700',
      MG: '#5DBB63',
      PA: '#E63B2E',
      PB: '#FF5733',
      PR: '#4F5D75',
      PE: '#FFB6C1',
      PI: '#6A0572',
      RJ: '#FF5E5E',
      RN: '#317589',
      RS: '#FFE4E1',
      RO: '#084C61',
      RR: '#FF8C69',
      SC: '#90EE90',
      SP: '#005FAE',
      SE: '#48D1CC',
      TO: '#C71585',
    },
  },
  shadow: {
    default:
      '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
  },
};

export default theme;
